<template>
  <div class="home">
    <NavBar id="nav" />
    <main class="con">
      <router-view />
    </main>
    <footer>
      <div class="pre-footer">
        <div class="backdrop">
          <div class="overlay"></div>
          <img :src="require('@/assets/images/texture_grazed.png')" alt="" />
        </div>
        <div class="content row vcenter container">
          <div class="buttons">
            <router-link :to="{ name: 'Login' }" class="btn mb-2">
              login
            </router-link>
            <router-link :to="{ name: 'Signup' }" class="btn">
              signup
            </router-link>
            <!-- <button class="mt-2">Visit our blog</button> -->
          </div>
          <!-- <div class="social-links right">
            facebook
          </div> -->
        </div>
      </div>
      <div class="main-footer primary-dark text-center">
        <span>&copy; CurioTravels</span><br />
        <span>
          All Rights reserved
          <span>{{ new Date().getFullYear() }}</span>
        </span>
      </div>
    </footer>
  </div>
</template>

<script>
import NavBar from "@/components/nav/NavBar";

export default {
  name: "Landing",
  metaInfo() {
    return {
      title: "Curio Travels",
    };
  },
  components: {
    NavBar,
  }
};
</script>

<style lang="scss" scoped>
#nav {
  position: fixed;

  &.translucent {
    color: white;
    background-color: #00000079;
  }
}

footer {
  .pre-footer {
    height: 180px;
    position: relative;

    .overlay {
      background-color: transparent;
    }
    .content {
      position: relative;
      height: 100%;

      .btn {
        display: block;
      }
    }
  }

  .main-footer {
    padding: 10px;
    color: white;
    background-color: #351800;
  }
}
</style>
